export const PACKAGE_HASH_PREFIX = 'package-';
